var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { useEffect, useState } from 'react';
import { Field } from 'react-redux-form';
import { connect } from 'react-redux';
import { orderBy } from 'lodash';
import { Select } from "../../ReactReduxForms";
import { Translate, t } from "../../I18N";
import { Warning } from "../../Layout";


import PropertyConfigOptions from "./PropertyConfigOptions";
import { checkErrorsOnLabel } from "../utils/checkErrorsOnLabel";






const mapStateToProps = (state, ownProps) => {
  const { template, thesauris } = state;
  const property = template.data.properties ? template.data.properties[ownProps.index] : undefined;
  return {
    labelHasError: checkErrorsOnLabel(state, ownProps),
    contentRequiredError:
    //@ts-ignore
    template.formState.$form.errors[`properties.${ownProps.index}.content.required`],
    templateId: template.data._id,
    thesauris,
    property,
    content: property === null || property === void 0 ? void 0 : property.content,
    index: ownProps.index,
    type: ownProps.type
  };
};

const connector = connect(mapStateToProps);



const FormConfigSelectComponent = ({
  index,
  type,
  labelHasError,
  contentRequiredError,
  templateId,
  property,
  content,
  thesauris
}) => {
  const [warning, setWarning] = useState(false);
  const [initialContent] = useState(content);

  useEffect(() => {
    if (initialContent !== content && property !== null && property !== void 0 && property._id) {
      setWarning(true);
    }
  }, [content]);

  const options = orderBy(
    thesauris.
    toJS().
    filter(
      (thesaurus) =>
      thesaurus._id !== templateId && thesaurus.type !== 'template'
    ).
    map((thesaurus) => _objectSpread(_objectSpread({},
    thesaurus), {}, {
      name: t(thesaurus._id.toString(), thesaurus.name, null, false) })
    ),
    'name'
  );

  return (/*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx("div", { className: `form-group${labelHasError ? ' has-error' : ''}` }, void 0, /*#__PURE__*/
    _jsx("label", { htmlFor: "property-label" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Label")
    ), /*#__PURE__*/
    _jsx(Field, { model: `template.data.properties[${index}].label` }, void 0, /*#__PURE__*/
    _jsx("input", { className: "form-control", id: "property-label" })
    )
    ), /*#__PURE__*/

    _jsx("div", { className: "form-group" }, void 0, /*#__PURE__*/
    _jsx("label", { htmlFor: "property-type" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Type")
    ), /*#__PURE__*/
    _jsx("span", { className: "property-type-warning" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "This cannot be changed after saving")
    ), /*#__PURE__*/
    _jsx(Field, { model: `template.data.properties[${index}].type` }, void 0, /*#__PURE__*/
    _jsx("select", {
      name: "type",
      id: "property-type",
      className: "form-control",
      disabled: !!(property !== null && property !== void 0 && property._id) }, void 0, /*#__PURE__*/

    _jsx("option", { value: "select" }, void 0, t('System', 'Single select', null, false)), /*#__PURE__*/
    _jsx("option", { value: "multiselect" }, void 0, t('System', 'Multiple select', null, false))
    )
    )
    ), /*#__PURE__*/

    _jsx("div", { className: contentRequiredError ? 'form-group has-error' : 'form-group' }, void 0, /*#__PURE__*/
    _jsx("label", { htmlFor: "property-thesauri" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Thesauri"), /*#__PURE__*/
    _jsx("span", { className: "required" }, void 0, "*")
    ),
    warning && /*#__PURE__*/
    _jsx(Warning, { inline: true }, void 0, /*#__PURE__*/
    _jsx(Translate, { translationKey: "Impact of property change warning" }, void 0, "By making this change, any values from the previous thesaurus already assigned to entities will be lost."


    )
    ), /*#__PURE__*/

    _jsx(Select, {
      model: `template.data.properties[${index}].content`,
      options: options,
      optionsLabel: "name",
      optionsValue: "_id",
      id: "property-thesauri" }
    )
    ), /*#__PURE__*/

    _jsx(PropertyConfigOptions, { index: index, type: type })
    ));

};

const container = connector(FormConfigSelectComponent);
export { container as FormConfigSelect };